import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { RequiredDirective } from '../../misc/directives/required.directive';
import { MiscModule } from '../../misc/misc.module';
import { ParcelNumberPageRoutingModule } from './parcel-number-routing.module';
import { ParcelNumberPageComponent } from './parcel-number.page';

@NgModule({
  declarations: [ParcelNumberPageComponent],
  imports: [
    CommonModule,
    IonicModule,
    ParcelNumberPageRoutingModule,
    FormsModule,
    MiscModule,
    ReactiveFormsModule,
    ErrorMessageDirective,
    RequiredDirective
  ]
})
export class ParcelNumberPageModule {}
